import { render, staticRenderFns } from "./regPhone.vue?vue&type=template&id=23317d5a&scoped=true&"
import script from "./regPhone.vue?vue&type=script&lang=js&"
export * from "./regPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23317d5a",
  null
  
)

export default component.exports